import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled } from "../theme";
import { H2, Text } from "../text";
import { Card } from "../card";
export const FormCard = ({ title, description, children, }) => (_jsxs(StyledCard, { children: [_jsx(H2, { children: title }), description && _jsx(Text, { fontSize: 16, children: description }), _jsx(Space, { children: children })] }));
const StyledCard = styled(Card) `
  padding: ${({ theme }) => theme.space[7]}px;
  margin-bottom: ${({ theme }) => theme.space[5]}px;
`;
const Space = styled.div `
  margin-top: ${({ theme }) => theme.space[5]}px;
`;
